import { observable, action, runInAction } from "mobx";
import { CommonStore } from "./CommonStore";
import { RootStore } from ".";
import { fetchWrapper } from "../common/Fetch";
import { SuccessableResult } from "../common/BaseClasses";
import { NotificationLevel } from "./NotificationStore";
import { BindedUser } from "../routes/AbtekaToAsBinding/AbtekaToAsUserPage";


export interface UserInfo {
    userId: string;
    userFio: string;
    email: string;
    rolesCount: number;
    roles: string[];
}



export class UsersStore {


    _rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
        this.commonStore = this._rootStore.commonStore;
    }

    private commonStore: CommonStore;


    @observable users: UserInfo[] = [];
    @observable bindedUsers: BindedUser[] = [];


    @action
    loadUsers(callback?: () => void) {
        fetchWrapper(`/api/Users/users`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
            this.commonStore, true)
            .then(res => res.json() as Promise<UserInfo[]>)
            .then(result => {
                runInAction("fetch complete loadUsers", () => {
                    this.users = result;
                    if (callback != undefined)
                        callback();
                });
            });
    }

    @action
    loadBindedUsers(callback?: () => void)  {
        fetchWrapper(`/api/Users/getbindedas`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
            this.commonStore, true)
            .then(res => res.json() as Promise<BindedUser[]>)
            .then(result => {
                runInAction("fetch complete loadBindedUsers", () => {
                    this.bindedUsers = result;
                    if (callback != undefined)
                        callback();
                });
            });
    }

    // @action
    // loadRoles(id: string, callback: (roles: string[]) => void) {
    //     fetchWrapper(`/api/Roles/edit/${id}`, {
    //         method: 'GET',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         }
    //     },
    //         this.commonStore, true)
    //         .then(res => res.json() as Promise<string[]>)
    //         .then(result => {
    //             runInAction("fetch complete loadRoles", () => {
    //                 callback(result);
    //             });
    //         });
    // }
    @action
    saveRoles(userId: string, roles: string[], successCallback: () => void) {
        const data = new FormData();
        data.append('userId', userId);
        roles.forEach(role => {
            data.append('roles[]', role);
        })
        fetchWrapper('/api/Users/edit', {
            method: 'POST',
            body: data,//JSON.stringify({ email: email, roles: roles }),
            // headers: {
            //     'Content-Type': 'application/x-www-form-urlencoded'
            // }
        },
            this.commonStore, true)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete saveRoles", () => {
                    if (result.isSuccess) {
                        successCallback();
                        this._rootStore.notificationStore.addNotification("Роли сохранены успешно!", NotificationLevel.info);
                    }
                    else
                        this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
                });
            });
    }

    // @action
    // saveArticleReplacements(brand: string, articleTo: string, articlesFrom: string[], successCallback: () => void) {
    //     fetchWrapper('/api/ArticleReplacements', {
    //         method: 'POST',
    //         body: JSON.stringify({ Brand: brand, ArticleTo: articleTo, ArticlesFrom: articlesFrom }),
    //         headers: {
    //             'Content-Type': 'application/json'
    //         }
    //     },
    //         this.commonStore, true)
    //         .then(res => res.json() as Promise<SuccessableResult<any>>)
    //         .then(result => {
    //             runInAction("fetch complete saveArticleReplacements", () => {
    //                 if (result.isSuccess)
    //                     successCallback();
    //                 else
    //                     this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
    //             });
    //         });
    // }

    // @action removeArticleReplacement(brand: string, article: string, successCallback: () => void) {
    //     fetchWrapper(`/api/ArticleReplacements?brand=${brand}&article=${article}`, {
    //         method: 'DELETE',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         }
    //     },
    //         this.commonStore, true)
    //         .then(res => res.json() as Promise<SuccessableResult<any>>)
    //         .then(result => {
    //             runInAction("fetch complete removeArticleReplacement", () => {
    //                 if (result.isSuccess)
    //                     successCallback();
    //                 else
    //                     this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
    //             });
    //         });
    // }

    @action
    bindAsUser(bindedUsers:BindedUser[]) {
        fetchWrapper(`/api/Users/BindAsAccount`, {
            method: 'POST',
            body: JSON.stringify(bindedUsers),
            headers: {
                'Content-Type': 'application/json'
            }
        },
            this.commonStore, true)
            .then(res =>
                res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete bindAsUser", () => {
                    if (result.isSuccess) {
                        this._rootStore.notificationStore.addNotification("Аккаунты привязан!", NotificationLevel.info);                        
                    }
                    else
                        this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
                });
            });
    }

    @action
    createUser(email: string, password: string, lastName: string, firstName: string, middleName: string, successCallback: () => void) {
        const data = new FormData();
        data.append('email', email);
        data.append('password', password);
        data.append('lastName', lastName);
        data.append('firstName', firstName);
        data.append('middleName', middleName);

        fetchWrapper('/api/Users/Create', {
            method: 'POST',
            body: data,//JSON.stringify({ email: email, roles: roles }),
            // headers: {
            //     'Content-Type': 'application/x-www-form-urlencoded'
            // }
        },
            this.commonStore, true)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete saveRoles", () => {
                    if (result.isSuccess) {
                        successCallback();
                        this._rootStore.notificationStore.addNotification("Пользователь создан!", NotificationLevel.info);
                        this.users.push(result.data);
                    }
                    else
                        this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
                });
            });
    }

    @action
    removeUser(userId: string) {
        fetchWrapper(`/api/Users/Remove/${userId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        },
            this.commonStore, true)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete removeUser", () => {
                    if (result.isSuccess)
                        this.users = [...this.users.filter(w => w.userId != userId)];
                    else
                        this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
                });
            });
    }
}